import React from 'react';
import Output from 'components/Tvendo/Inventory/Operations/Kardex/KardexSharedFile';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <Output
      title="salidas"
      excelName="salidas"
      type="OT" // OP = outputs
      entity="logi/output"
      permissions={{
        store: ConstantPermissions.LOGI_OUTPUTS_STORE,
        show: ConstantPermissions.LOGI_OUTPUTS_SHOW,
        delete: ConstantPermissions.LOGI_OUTPUTS_DELETED
      }}
    />
  );
}
